export const MSAL_RETURN_SUBDOMAIN_STATE_PREFIX = 'ommnio-sub:';

export const buildMsalReturnSubdomainState = subdomain =>
  `${MSAL_RETURN_SUBDOMAIN_STATE_PREFIX}${subdomain}`;

const readSubdomainFromState = state => {
  if (!state?.startsWith(MSAL_RETURN_SUBDOMAIN_STATE_PREFIX)) {
    return null;
  }
  const sub = state.slice(MSAL_RETURN_SUBDOMAIN_STATE_PREFIX.length);
  return /^[a-z0-9-]+$/i.test(sub) ? sub : null;
};

const readSubdomainFromUrlPart = part => {
  if (!part) {
    return null;
  }
  const normalized = part.startsWith('?') || part.startsWith('#') ? part.slice(1) : part;
  return readSubdomainFromState(new URLSearchParams(normalized).get('state'));
};

/** MSAL may return `state` in the query string or the hash fragment depending on response mode. */
export const parseSubdomainFromMsalState = (search = '', hash = '') =>
  readSubdomainFromUrlPart(search) || readSubdomainFromUrlPart(hash);
